import { sendWebsocketMessage } from '../../../../../../App';

export function enterLong(tradePlanId) {
  const msg = {
    messageType: 'updateTradePlan',
    tradePlanId,
    field: 'enterLong',
    value: {},
  };
  sendWebsocketMessage(msg);
}

export function enterShort(tradePlanId) {
  const msg = {
    messageType: 'updateTradePlan',
    tradePlanId,
    field: 'enterShort',
    value: {},
  };
  sendWebsocketMessage(msg);
}
